import axiosApi from 'utils/axios';

export const translateThunk = (values) => async () => {
  const data = await axiosApi.post('/translations/translate', values).then((data) => data);
  return data;
};
